
import { Component, Vue } from 'vue-property-decorator'
import { addCompany, chooseUserType, CompanyInfo } from '@/api/creatCompany'
import { Action, Getter } from 'vuex-class'
import { CompanyAddDto, getCompanyCode } from '@/api/customerManage'
import { DictDataDto, getSyDictDataInfo } from '@/api/commonConfig'
import store from '@/store'
import { LoginReturnDataDto, toAccountSetting,openNewPage } from '@/utils/h5ToApp'
import { Debounce } from '@/core/decorator'
import {
  getCompanyInfoByPartner,
  getCompareCode,
  modifyBindingVersionCode
} from '@/api/company'
import { getPreCredit, getPreCreditUrl } from '@/api/preCredit'

@Component({
  name: 'CreateCompany'
})
export default class CreateCompany extends Vue {
  @Getter mobile!: string
  @Getter userId!: string
  @Getter info!: LoginReturnDataDto
  @Action setCompanyId!: (val: string) => void

  labelWidth = '6em'
  formData: CompanyAddDto = {
    companyName: '',
    industryId: '',
    industryName: '',
    postInfo: '',
    dimensionsId: '',
    dimensionsName: '',
    companyType: 1,
    registMobile: '',
    companyCode: '',
    versionCode: ''
  }
  showIndustryPicker = false
  showDimensionsPicker = false
  industryList: DictDataDto[] = []
  dimensionsList: DictDataDto[] = []
  showSetting = false

  isSubmit = false

  show = false
  canPreCredit = false
  msg1 = ''
  msg2 = ''

  created() {
    this.formData.registMobile = this.mobile
    this.getIndustryList()
    this.getDimensionsList()
    this.showSetting = this.$route.query.fromPage !== '1'
  }
  /**
  * @description: 获取预授信免登陆接口
  * @param {*} null
  * @return {*} null
  */
  handleConfirm() {
    console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    if(!this.canPreCredit) return
    getPreCreditUrl(params).then(res => {
        console.log('getPreCreditUrl',res);
        openNewPage({url: encodeURI(res.data.redirectUrl)})
    })
  }
  /**
   * @description: 预授信入口
   * @param {*}
   * @return {*}
   */
  handlePreCredit() {
     console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    this.msg1 = ''
    this.msg2 = ''
    this.show = true
    getPreCredit(params).then((res) => {
      console.log('getPreCredit', res)
      if (res.code === '000000') {
        this.canPreCredit = true
      } else if (res.code === '000002') {
        this.canPreCredit = false
      }
      this.msg1 = res.data.msg
      this.msg2 = res.data.msg2
    })
  }

  // 获取行业字典表
  getIndustryList() {
    getSyDictDataInfo({ dictTypeId: 'industry' })
      .then((res: any) => {
        this.industryList = res.data || []
      })
      .catch(() => {})
  }

  // 获取企业规模字典表
  getDimensionsList() {
    getSyDictDataInfo({ dictTypeId: 'enterpriceScale' })
      .then((res: any) => {
        this.dimensionsList = res.data || []
      })
      .catch(() => {})
  }

  // input输入限制（英文、数字）独立编码
  formatterInput(value) {
    return value.replace(/[^a-zA-Z\d]/g, '') // 英文和数字
  }

  formatterInput2(value) {
    return value.replace(/[^a-zA-Z\d]/g, '').toUpperCase() // 大写英文和数字
  }

  //行业选择弹出框
  industryConfirm(value: DictDataDto) {
    this.formData.industryId = value.dataId
    this.formData.industryName = value.dataName
    this.showIndustryPicker = false
  }

  // 企业规模选择弹出框
  dimensionsConfirm(value: DictDataDto) {
    this.formData.dimensionsId = value.dataId
    this.formData.dimensionsName = value.dataName
    this.showDimensionsPicker = false
  }

  @Debounce(500) // 防抖
  addSure() {
    if (this.isSubmit)
      return false // 防止用户触发多次提交误点
    ;(this.$refs.creatCompany as any).validate().then(() => {
      // 如果版本邀请码不为空的话, 需要先校验邀请码的准确性==>  添加公司 ==> 进入公司接口 ==> 切换版本码 ==> 获取合作方信息 ==> 替换原生userInfo ==> 进如公司enterCompany
      // if (!this.$checkIsEmpty(this.formData.versionCode)) {
      //     this._checkVersionCode()
      //     return false
      // }
      this.isSubmit = true
      this.formData.registMobile = this.mobile
      addCompany(this.formData)
        .then((res) => {
          if (res.code === '000000') {
            this.toHome(res.data)
          } else if (res.code === '000001') {
            this.$toast(res.msg)
            // 邀请码错误 清空邀请码
            this.formData.versionCode = ''
          }
        })
        .catch((err) => {
          if (err.data.code === '000001') {
            this.$toast(err.data.msg)
            // 邀请码错误 清空邀请码
            this.formData.versionCode = ''
          }
        })
        .finally(() => {
          this.isSubmit = false
        })
    })
  }

  /**
   * 1:检查邀请码是否有效
   * 2:新增公司
   */
  _checkVersionCode() {
    // 匹配邀请码 判断填写的邀请码是否有效
    getCompareCode({ versionCode: this.formData.versionCode })
      .then((res) => {
        if (res.code === '000001') {
          this.$toast(res.msg)
          // 邀请码错误 清空邀请码
          this.formData.versionCode = ''
        }

        let params = {
          type: '1', // 邀请码or版本码
          versionCode: this.formData.versionCode
        }
        this.isSubmit = true
        this.formData.registMobile = this.mobile
        // 新增公司
        addCompany(this.formData)
          .then((res) => {
            if (res.code === '000000') {
              // 切换版本号
              // this._modifyBindingVersionCode(res.data)
              // 回到公司列表选择页面
              this.$router.back()
            } else if (res.code === '000001') {
              this.$toast(res.msg)
              // 邀请码错误 清空邀请码
              this.formData.versionCode = ''
            }
          })
          .catch((err) => {
            if (err.data.code === '000001') {
              this.$toast(err.data.msg)
              // 邀请码错误 清空邀请码
              this.formData.versionCode = ''
            }
          })
          .finally(() => {
            this.isSubmit = false
          })
      })
      .catch((err) => {
        if (err.data.code === '000001') {
          this.$toast(err.data.msg)
          // 邀请码错误 清空邀请码
          this.formData.versionCode = ''
        }
      })
  }

  /**
   * 切换版本号
   * 获取 合作方公司信息
   * 进入公司
   */
  _modifyBindingVersionCode(info: CompanyInfo) {
    this.setCompanyId(info.companyId)
    // 切换版本号
    modifyBindingVersionCode({ versionCode: this.formData.versionCode }).then(
      (datas) => {
        // 获取合作方信息
        getCompanyInfoByPartner({
          partnerCompanyId: datas.data.partnerCompanyId
        }).then((partnerData) => {
          const param = {
            oldUserId: this.userId, // 登录账号userId
            userId: info.userId // 新创建的公司对应的userId
          }
          chooseUserType(param)
            .then((res) => {
              const data = res.data
              this.$toast.success({
                message: '创建公司成功',
                duration: 1000,
                onClose: () => {
                  store.commit('SET_TOKEN', data.access_token)
                  store.commit('SET_INFO', data)
                  store.commit('SET_USERID', data.userId)
                  const obj = {
                    companyInfo: {
                      companyId: info.companyId,
                      userId: info.userId,
                      loginName: info.loginName,
                      companyName: this.formData.companyName,
                      partnerLogoUrl: partnerData.data.logoUrl, // 合作方Logo
                      partnerCompanyId: partnerData.data.companyId, // 合作方Id
                      partnerCompanyName: partnerData.data.companyName, // 合作方名称
                      versionCode: this.formData.versionCode, // 版本号
                      partnerCompanyShortName: partnerData.data.companyShortName // 合作方简称
                    },
                    userInfo: data
                  }
                  this.$bridge.callHandler('enterCompany', obj, (res) => {
                    console.log(res)
                  })
                }
              })
            })
            .catch(() => {})
        })
      }
    )
  }

  /**
   *  进去公司
   *  调原生enterCompany进去公司方法
   */
  toHome(info: CompanyInfo) {
    this.$router.push('/ChooseCompany')
    // const param = {
    //     oldUserId: this.userId, // 登录账号userId
    //     userId: info.userId // 新创建的公司对应的userId
    // }
    // chooseUserType(param).then((res) => {
    //     const data = res.data
    //     this.$toast.success({
    //         message: '创建公司成功',
    //         duration: 1000,
    //         onClose: () => {
    //             this.setCompanyId(info.companyId)
    //             store.commit('SET_TOKEN', data.access_token)
    //             store.commit('SET_INFO', data)
    //             store.commit('SET_USERID', data.userId)
    //             const obj = {
    //                 companyInfo: {
    //                     companyId: info.companyId,
    //                     userId: info.userId,
    //                     loginName: info.loginName,
    //                     companyName: this.formData.companyName
    //                 },
    //                 userInfo: data
    //             }
    //             this.$bridge.callHandler('enterCompany', obj, (res) => {
    //                 console.log(res)
    //             })
    //         }
    //     })
    // }).catch(() => {})
  }

  // 账号设置
  toSetting() {
    const obj = {
      userType: this.info.userType
    }
    toAccountSetting(obj)
  }

  companyNameBlur() {
    /* 前端调用后端接口获取拼音首字母 */
    getCompanyCode({ companyCode: this.formData.companyName }).then((res) => {
      this.formData.companyCode = res.data || ''
    })
  }
}
